import { put, takeLatest } from "redux-saga/effects";

import {
  fetchEmailListRequest,
  fetchEmailListSuccess,
  fetchEmailListFailure,
  EmailListCreateRequest,
  EmailListCreateSuccess,
  EmailListCreateFailure,
  editEmailListStatusRequest,
  editEmailListStatusSuccess,
  editEmailListStatusFaliure,
} from "redux/reducers/acclgl/emailList";
import {
  requestEmailList,
  requestEmailListCreate,
  editEmailListStatus,
} from "services/acclgl/emailList";

export function* watchEmailListSaga() {
  yield takeLatest(fetchEmailListRequest, fetchEmailList);
  yield takeLatest(EmailListCreateRequest, emaillistcreate);
  yield takeLatest(editEmailListStatusRequest, emaillistupdatestatus);
}

function* fetchEmailList({ payload }) {
  try {
    const response = yield requestEmailList(payload);
    yield put(fetchEmailListSuccess(response));
  } catch (error) {
    yield put(fetchEmailListFailure("Failed to get Email list"));
  }
}
function* emaillistcreate({ payload }) {
  try {
    const response = yield requestEmailListCreate(payload);
    yield put(EmailListCreateSuccess(response.data));
  } catch (error) {
    yield put(EmailListCreateFailure("Failed to create Email List"));
  }
}
function* emaillistupdatestatus({ payload }) {
  try {
    const response = yield editEmailListStatus(payload);
    yield put(editEmailListStatusSuccess(response));
  } catch (error) {
    yield put(editEmailListStatusFaliure("Failed to get update Email List Status"));
  }
}